<template>
  <v-card outlined class="app-card">
    <v-card-title class="app-card-title">Solicitação</v-card-title>
    <v-card-text class="app-card-content">
      <v-row v-if="data">
        <v-col :md="4" :sm="4" :xs="12" cols="12" class="pt-0 pb-0">
          <v-text-field v-model="data.id" label="Número" readonly filled rounded dense></v-text-field>
        </v-col>
        <v-col :md="4" :sm="4" :xs="12" cols="12" class="pt-0 pb-0">
          <v-text-field v-model="data.area.nome" label="Área" readonly filled rounded dense></v-text-field>
        </v-col>
        <v-col :md="4" :sm="4" :xs="12" cols="12" class="pt-0 pb-0">
          <v-text-field
            v-model="data.tipoSolicitacao.nome"
            label="Tipo"
            readonly
            filled
            rounded
            dense
          ></v-text-field>
        </v-col>
        <v-col :md="12" :sm="12" :xs="12" cols="12" class="pt-0 pb-0">
          <v-text-field
            v-model="data.agenteRegulado.nome"
            label="Empresa"
            readonly
            filled
            rounded
            dense
          ></v-text-field>
        </v-col>
        <v-col :md="12" :sm="12" :xs="12" cols="12" class="pt-0 pb-0">
          <v-textarea
            v-model="data.pretensao"
            label="Pretensão"
            rows="3"
            readonly
            filled
            rounded
            dense
          ></v-textarea>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "Solicitacao",
  props: { data: Object }
};
</script>
